var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebcam = function SvgWebcam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.58 12.248a6.25 6.25 0 1 1 8.84 8.838 6.25 6.25 0 0 1-8.84-8.838m4.42.669a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.057 4.733a12.916 12.916 0 0 1 13.084 21.962l3.083 5.138a2.92 2.92 0 0 1-1.032 4.019c-.445.26-.952.397-1.468.398H11.277a2.92 2.92 0 0 1-2.537-1.48 2.92 2.92 0 0 1 .036-2.936l3.083-5.14a12.9 12.9 0 0 1-3.792-5.084 12.917 12.917 0 0 1 6.99-16.877m-1.112 23.343-3.024 5.043a.417.417 0 0 0 .356.63h17.445a.417.417 0 0 0 .357-.63l-3.024-5.043A12.9 12.9 0 0 1 20 29.583a12.9 12.9 0 0 1-6.055-1.507M20 6.25a10.416 10.416 0 1 0 0 20.833A10.416 10.416 0 0 0 20 6.25",
    clipRule: "evenodd"
  })));
};
export default SvgWebcam;